module.exports = __webpack_public_path__ + "static/en-sm-4-09ca72d22378282cb3d46d13c11a345d.png";